import { Asset } from './Asset';
import { Model } from './Model';
import { PainterSmartMaterial } from './PainterSmartMaterial';
import { AssetType } from './RawAsset';
import { SubstanceAtlas } from './SubstanceAtlas';
import { SubstanceDecal } from './SubstanceDecal';
import { SubstanceIbl } from './SubstanceIbl';
import { SubstanceMaterial } from './SubstanceMaterial';
import { SubstanceModel } from './SubstanceModel';

type AssetClass =
  | Asset
  | SubstanceMaterial
  | SubstanceAtlas
  | SubstanceDecal
  | PainterSmartMaterial
  | Model
  | SubstanceModel
  | SubstanceIbl;

/**
 * Create an instance of asset based on its type
 * @param {Object} asset a raw asset returned by the API
 * @returns {AssetClass | null} an instance of asset type or of Asset or a child of Asset
 */
function assetFactory(asset: { type?: string }): AssetClass | null {
  const Cls = {
    [AssetType.MATERIAL]: SubstanceMaterial,
    [AssetType.ATLAS]: SubstanceAtlas,
    [AssetType.DECAL]: SubstanceDecal,
    [AssetType.SMART_MATERIAL]: PainterSmartMaterial,
    [AssetType.MODEL]: Model,
    [AssetType.SUBSTANCE_MODEL]: SubstanceModel,
    [AssetType.FILTER]: Asset,
    [AssetType.TEXTURE_GENERATOR]: Asset,
    [AssetType.MESH_BASED_GENERATOR]: Asset,
    [AssetType.IBL]: SubstanceIbl
  };

  try {
    if (asset.type && Cls[asset.type as AssetType]) {
      return new Cls[asset.type as AssetType](asset);
    }
  } catch (error) {
    console.error(error);
  }

  return null;
}

export { assetFactory, AssetClass };
